import { constantRouterMap } from '@/router'
import { deepClone } from '@/utils/index'
import { markRaw } from 'vue'
import Layout from '@/views/layout/Layout'

// 注意：这里与 Layout.vue 存在循环依赖，模块求值时 Layout 还是 undefined，
// 不能在模块顶层 markRaw(Layout)；在 moduleToRoute 运行时再标记。

// 路由名去重：Vue Router 4 要求 name 全局唯一，且嵌套路由不能与祖先同名
// （Vue2 时允许同名，菜单里同名父子节点会直接触发该异常）
const uniqueRouteName = (item, usedNames) => {
    const base = item.name || `route_${item.id}`
    if (!usedNames.has(base)) {
        usedNames.add(base)
        return base
    }
    let name = `${base}_${item.id}`
    let i = 2
    while (usedNames.has(name)) {
        name = `${base}_${item.id}_${i++}`
    }
    usedNames.add(name)
    return name
}

//将模块数据转换为vue的Router结构，顶级的模块使用layout视图
const moduleToRoute = (data, dispatch, usedNames = new Set()) => {
    // url 清洗：菜单表里存在 ' '（纯空格）、''（空串）以及不带前导斜杠（如 '14'）的脏数据。
    // Vue Router 3 的 matcher 容忍这些写法，Vue Router 4 对「顶级路由」强制要求以 '/' 开头，
    // 否则直接抛 Route paths should start with a "/": " " should be "/ ".
    const rawUrl = (data.item.url || '').trim()
    const isExternal = /^(https?:)?\/\//i.test(rawUrl)
    let parentPath = rawUrl.indexOf('?') > -1 ? rawUrl.split('?')[0] : rawUrl
        //查询参数,在SidebarItem再加上参数,应该是为了绕过路由
    const querydata = rawUrl.indexOf('?') > -1 ? rawUrl.split('?')[1] : '';
    // 顶级路由（addRoute 时按绝对路径处理）必须补前导斜杠；子路由保留相对写法（VR4 支持，且与 Vue2 行为一致）
    if (data.item.parentId === null && parentPath && !isExternal && parentPath.charAt(0) !== '/') {
        parentPath = '/' + parentPath
    }
    const tabTitle = data.item.name
        // const parentPath = data.item.url;
    var newPath = {
        path: parentPath || '/',
        // markRaw：防止 Layout 随路由记录存进 Vuex 响应式 state 时被深度响应式化，
        // 否则 RouterView 渲染响应式组件会告警 "Vue received a Component that was made a reactive object..."
        component: data.item && data.item.parentId === null ? markRaw(Layout) :
            () =>
            import ('@/views' + parentPath.toLowerCase()),
        meta: {
            title: data.item.name,
            sortNo: data.item.sortNo,
            icon: data.item.iconName || 'streamlist',
            elements: data.item && data.item.elements || '',
            url: data.item.url,
            code: data.item.code,
            id: data.item.id
        },
        name: uniqueRouteName(data.item, usedNames),
        hidden: false,
        children: []
    }
    if (newPath.path.indexOf('http') > -1) {
        let obj = {}
        obj[newPath.meta.code] = {
            name: newPath.name,
            url: newPath.meta.url
        }
        dispatch('setIframeTagViews', obj, { root: true })
    }
    newPath.path = newPath.path.indexOf('http') > -1 ? `/iframePage/${newPath.meta.code}` : newPath.path
    if (data.children && data.children.length > 0) {
        data.children.forEach(child => {
            newPath.children.push(moduleToRoute(child, dispatch, usedNames))
        })
    }
    newPath.querydata = querydata;
    if (querydata) {
        newPath.tabTitle = tabTitle;
    }

    return newPath
}

//与初始定义的路由合并，并把根模块挂到根路由'/'下面
const mergeModuleWithConst = (data) => {
    let rootModule = []
    data.length > 0 && data.forEach(item => {
        if (item.component && item.component.name && item.component.name === 'layout') {
            let obj = {
                component: () =>
                    import ('@/views' + item.path.toLowerCase()),
                path: item.children && item.children.length > 0 ? `${item.path}/${item.meta.id}` : item.path,
                name: item.name,
                children: item.children,
                meta: item.meta
            }
            rootModule = rootModule.concat(obj)
            return
        }
        arr.push(item)
    })

    var arr = deepClone(constantRouterMap)
    arr.length > 0 && arr.forEach(item => {
        if (item.name === 'layout') { //把模块的根路由放到'/'下面
            item.children = item.children.concat(rootModule)
        }
    })
    return arr
}
const groupData = (data) => {
    if (data.children && data.children.length > 0) {
        data.children.forEach(child => {
            let code = groupData(child)
            code && (code = code.replace(code[0], code[0].toLowerCase()))
            code && code !== undefined && permission.state.keepAliveData.push(code)
        })
        return
    }
    return data.meta.code
}

// //把所有的2级以上路由都挂载到顶级layout下面，否则不能识别
const moveDeepLevelToSec = (router) => {
    router.children &&
        router.children.length > 0 &&
        (router.children = moveDeepLevelChildrenToSec(router.children, []))
    return router
}
const moveDeepLevelChildrenToSec = (children, res) => {
    if (Array.isArray(children)) {
        for (let i = 0; i < children.length; i++) {
            children[i].children && children[i].children.length > 0 &&
                (res = moveDeepLevelChildrenToSec(children[i].children, res))

            children[i].children && children[i].children.length > 0 && (children[i].children = [])
            moveDeepLevelChildrenToSec(children[i], res)
        }
    } else {
        res.push(children)
    }
    return res
}
const permission = {
    state: {
        routers: [], //仅用于渲染导航菜单Sidebar
        addRouters: [], //用于真正的路由控制
        keepAliveData: ['forms']
    },
    mutations: {
        SET_ROUTERS: (state, { addRouters, routers }) => {

            state.addRouters = addRouters
            state.routers = routers
        },
        SAVE_KEEP_ALIVE_DATA: (state, data) => {
            data && data.length > 0 && data.forEach(item => {
                let code = groupData(item)
                code && (code = code.replace(code[0], code[0].toLowerCase()))
                code && code !== undefined && state.keepAliveData.push(code)
            })
        }
    },
    actions: {
        async GenerateRoutes({ commit, dispatch }, data) {
            const moduleRoutes = [] //动态模块路由
            const usedNames = new Set() // 全局路由名集合，保证 name 唯一
            // 静态路由已占用的 name 也要纳入，避免动态菜单名与之相撞
            const collectNames = (routes) => {
                routes.forEach(r => {
                    if (r.name) usedNames.add(r.name)
                    if (r.children && r.children.length > 0) collectNames(r.children)
                })
            }
            collectNames(constantRouterMap)
            await data.modules.forEach((value) => {
                moduleRoutes.push(moduleToRoute(value, dispatch, usedNames))
            })

            //与静态路由组合成完整路由
            const routers = mergeModuleWithConst(deepClone([...moduleRoutes]), dispatch)

            //去掉路由中与constantRouterMap相同的项
            const noConstModuleRoutes = routers.find(item => item.name === 'layout')
                .children.filter(itemF => {
                    let constantRouter = !constantRouterMap
                        .find(item => item.name === 'layout').children.some(ele => ele.path === itemF.path)
                    return constantRouter
                })

            //todo:顶级的模块路由，把带component的路由添加到自己layout的子路由中？？？
            moduleRoutes.length > 0 && moduleRoutes.forEach(item => {
                    if (item.path.indexOf('/iframePage') <= -1 && item.children.length <= 0) {
                        item.children = noConstModuleRoutes.filter(router => router.path === item.path)
                    }
                })
                //把所有的2级以上路由都挂载到顶级layout下面，否则不能识别
            moduleRoutes.forEach(router => {
                moveDeepLevelToSec(router)
            })

            // todo:可以用最流氓的方法，全部转为一维数组😂
            // var arr=[];
            // const getAllItemsPerChildren = item => {
            //   arr.push(item);
            //   if (item.children.length>0) {
            //     return item.children.map(i => getAllItemsPerChildren(i));
            //   }
            // }
            //  moduleRoutes.forEach(router => {
            //   getAllItemsPerChildren(router)
            // })
            commit('SET_ROUTERS', { addRouters: moduleRoutes, routers: routers })
            commit('SAVE_KEEP_ALIVE_DATA', moduleRoutes)
        }
    },
    getters: {
        keepAliveData: state => state.keepAliveData
    }
}

export default permission